export const NAME = 'following';
